module.exports = __webpack_public_path__ + "img/chevronRight.007e13b9.svg";